import { createApiClient } from "@/api";
import { type DataProviderSchema } from "@/utils";
import { getLocalFilteredSortedList } from "@/utils/listParams";

const apiClient = createApiClient("jsonld");
const BASE_URL = "/api/vpn/cities";

const fetchListData = async () => {
  const response = await apiClient.GET(BASE_URL, {
    params: {
      query: {
        pagination: false,
      },
    },
  });

  const data = response.data?.["hydra:member"] ?? [];
  const total = response.data?.["hydra:totalItems"] ?? 0;

  return {
    data,
    total,
  };
};

export const citiesSchema: DataProviderSchema<"City", "jsonld"> = {
  list: getLocalFilteredSortedList(fetchListData),
  detail: async ({ id }) => {
    const { data } = await apiClient.GET(`${BASE_URL}/{id}`, {
      params: {
        path: { id: String(id) },
      },
    });

    if (!data) throw new Error("City not found");

    return { data };
  },
  edit: async ({ id, data: { name, heartbeatName } }) => {
    const { data } = await apiClient.PUT(`${BASE_URL}/{id}`, {
      params: {
        path: { id: String(id) },
      },
      body: {
        name,
        heartbeatName,
      },
    });

    if (!data) throw Error("Something went wrong");

    return { data };
  },
  create: async ({ data: { name, heartbeatName } }) => {
    const { data } = await apiClient.POST(BASE_URL, {
      body: {
        name,
        heartbeatName,
      },
    });

    if (!data) throw new Error("Something went wrong!");

    return {
      data,
    };
  },
};
